import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { loadLocales } from '../../utils/locale';
import intl from 'react-intl-universal';

export type LocalizationState = {
  legalUrl?: string;
  contactUrl?: string;
  termsOfServiceUrl?: string;
  privacyUrl?: string;
}

export const fetchLocale = createAsyncThunk<Partial<LocalizationState>>('localization/fetchLocal',
  async () => {
    const localization = await loadLocales(window?.navigator?.language);
    document.title = intl.get('title');
    return {
      termsOfServiceUrl: localization.termsOfService,
      privacyUrl: localization.privacyPolicy
    };
  }
);

const localizationSlice = createSlice({
  name: 'localization',
  initialState: {
    // This needs to be added to the localization service
    legalUrl: "https://www.lifesize.com/en/company/legal-notices",
    contactUrl: "https://www.lifesize.com/en/company/contact"
  } as LocalizationState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
  },
  extraReducers: builder => {
    builder.addCase(fetchLocale.fulfilled, (state, action) => ({
      ...state,
      ...action.payload
    }))
  }
});

export default localizationSlice.reducer;
